/**
 * skip third level menu
 * directly redirect to second level page
 */

  var mainNavSecondLevelItem = jQuery('.is-submenu-item a');

  jQuery(mainNavSecondLevelItem).on('click touchstart', function(event){
    if( 'medium' === Foundation.MediaQuery.current ){
      event.preventDefault();
      var linkAddress = jQuery(this).attr('href');
      window.location.href = linkAddress;

    }
  });
